import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableTextAreaInput',
  props: {
    textMessage: {
      type: String,
      required: true,
    },
    textAreaPlaceholder: String,
    doNotUpdateSize: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: null,
    },
  },
  emits: ['text-change'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const textInput = ref('')

  watch(textInput, (text) => {
    emit('text-change', text)
  })

  watch(
    () => props.textMessage,
    (text) => {
      textInput.value = text
    },
  )

  const expandTextAreaSize = (e: Event) => {
    const target = e.target as HTMLTextAreaElement
    const parent = target.parentNode as HTMLDivElement
    if (parent) {
      if (props.doNotUpdateSize) {
        e.preventDefault()
        return
      }
      textInput.value = target.value
    }
  }

return { __sfc: true,props, emit, textInput, expandTextAreaSize, ref, watch }
}

})